export class ParcBase {
	code!: string;
	description: string | null = null;
	energie: string | null = null;
	latitude: string | null = null;
	longitude: string | null = null;
	antenneId!: number;
	type: string | null = null;
	tarifNegatif!: boolean;
	responsableId: number | null = null;
	
	// typeOnduleur = true si onduleur decentralise
	typeOnduleur: boolean | null = null;
	
	niveauIncendie: number | null = null;
	regleIncendie: string | null = null;
	
	actif: boolean | null = null;
	
	vigilanceIncendie: string | null = null;
	hyperviseur: string | null = null;

	constructor() {
	}
}